import { Link } from "react-router-dom";
import { Col, Container, ListGroup, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./Footer.css";
export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="mt-auto py-4 bg-light border-top">
      <Container>
        <Row className="g-4">
          <Col md={4}>
            <h5 className="mb-3">KokoFin</h5>
            <p className="text-muted small">{t("footer.tagline")}</p>
          </Col>

          <Col md={4}>
            <h6 className="mb-3">{t("footer.quickLinks")}</h6>
            <ListGroup variant="flush">
              <ListGroup.Item className="ps-0 border-0">
                <Link to="/aboutus" className="text-muted text-decoration-none">
                  {t("footer.about")}
                </Link>
              </ListGroup.Item>
              <ListGroup.Item className="ps-0 border-0">
                <Link to="/faq" className="text-muted text-decoration-none">
                  {t("footer.faq")}
                </Link>
              </ListGroup.Item>
            </ListGroup>
          </Col>

          <Col md={4}>
            <h6 className="mb-3">{t("footer.legal")}</h6>
            <ListGroup variant="flush">
              <ListGroup.Item className="ps-0 border-0">
                <Link to="/privacy" className="text-muted text-decoration-none">
                  {t("footer.privacyPolicy")}
                </Link>
              </ListGroup.Item>
              <ListGroup.Item className="ps-0 border-0">
                <Link to="/terms" className="text-muted text-decoration-none">
                  {t("footer.termsOfService")}
                </Link>
              </ListGroup.Item>
            </ListGroup>
          </Col>
        </Row>

        <Row className="mt-4">
          <Col className="text-center text-md-start">
            <small className="text-muted">
              © {new Date().getFullYear()} KokoFin. {t("footer.rightsReserved")}
            </small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
